import { theme } from 'css/utils';

export const REACT_SELECT_STYLES = {
  menu: base => ({
    ...base,
    zIndex: 100
  }),
  valueContainer: provided => ({
    ...provided,
    display: 'block',
    maxWidth: '600px',
    flexWrap: 'nowrap',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    wordWrap: 'break-word',
    padding: '0',
    fontSize: '10px'
  }),
  indicatorSeparator: styles => ({
    ...styles,
    display: 'none'
  }),
  multiValue: styles => ({
    ...styles,
    minWidth: 'auto',
    background: '#333',
    color: '#fff',
    borderRadius: '50px',
    padding: '2px 0 2px 8px',
    fontSize: '10px',
    justifyContent: 'space-between'
  }),
  control: (styles, state) => ({
    ...styles,
    border: 'none',
    boxShadow: 'inset 0 0 2px 0 rgba(0, 0, 0, 0.1)',
    padding: '0 10px',
    minHeight: '35px',
    background: state.isDisabled ? `${theme.disabledField}` : `${theme.inputBackground}`,
    borderRadius: '5px',
    // maxHeight: '86px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center'
  }),
  placeholder: styles => ({
    ...styles,
    fontSize: '10px'
  }),
  dropdownIndicator: styles => ({
    ...styles,
    padding: '0'
  }),
  multiValueRemove: styles => ({
    ...styles,
    ':hover': {
      backgroundColor: 'transparent',
      color: 'white',
      opacity: '0.8'
    }
  }),
  multiValueLabel: styles => ({
    ...styles,
    color: '#fff'
  }),
  option: (base, state) => {
    // Handle disabled options
    if (state.isDisabled) {
      return {
        ...base,
        color: '#999',
        backgroundColor: '#FFFFFF',
        fontSize: '10px',
        cursor: 'not-allowed',
        textAlign: 'left',
        ':hover': {
          backgroundColor: '#FFFFFF'
        }
      };
    }

    if (state.data.selected !== undefined || state.data.selected !== null) {
      return {
        ...base,
        color: '#333',
        backgroundColor: state.data.selected || state.isFocused ? '#EFF1F1' : '#FFFFFF',
        fontWeight: state.data.selected && 'bold',
        fontSize: '10px',
        cursor: 'pointer',
        textAlign: 'left',
        ':hover': {
          backgroundColor: '#EFF1F1'
        }
      };
    }

    return {
      ...base,
      color: '#333',
      backgroundColor: state.isSelected || state.isFocused ? '#EFF1F1' : '#FFFFFF',
      fontWeight: state.isSelected && 'bold',
      fontSize: '10px',
      cursor: 'pointer',
      textAlign: 'left'
    };
  }
};
